import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function Benefits() {
  const benefits = [{
    title: 'Hojaldre Perfecto',
    description: 'Crujiente, dorado y estable (nunca más se te bajará).',
    emoji: '🥐'
  }, {
    title: 'Galletas Trendy',
    description: 'La textura exacta de las famosas galletas de New York.',
    emoji: '🍪'
  }, {
    title: 'Costos Bajo Control',
    description: 'Deja de adivinar precios y empieza a ganar dinero real.',
    emoji: '💰'
  }, {
    title: 'Libertad Financiera',
    description: 'Crea un catálogo que tus vecinos y amigos amarán.',
    emoji: '✨'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-cream-dark/30" data-id="element-11">
      <div className="max-w-7xl mx-auto" data-id="element-12">
        <div className="text-center mb-16" data-id="element-13">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-espresso mb-4" data-id="element-14">
            Lo que vas a lograr
          </h2>
          <p className="text-lg text-espresso-light font-sans" data-id="element-15">
            Resultados profesionales desde la primera horneada.
          </p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-16">
          {benefits.map((benefit, index) => <motion.div key={index} variants={itemVariants} className="bg-white rounded-2xl p-8 shadow-soft border border-caramel/10 hover:border-caramel/30 transition-colors relative overflow-hidden group" data-id="element-17">
              <div className="absolute -right-4 -top-4 text-6xl opacity-5 group-hover:scale-110 transition-transform duration-500" data-id="element-18">
                {benefit.emoji}
              </div>
              <div className="w-12 h-12 bg-caramel/10 rounded-xl flex items-center justify-center mb-6" data-id="element-19">
                <CheckCircle2 className="w-6 h-6 text-caramel" data-id="element-20" />
              </div>
              <h3 className="text-xl font-bold text-espresso mb-3 font-serif" data-id="element-21">
                {benefit.title}
              </h3>
              <p className="text-espresso-light font-sans leading-relaxed" data-id="element-22">
                {benefit.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}